// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DwLiw","col":"styles_col__1RgBe"};